import * as React from 'react';
import { cn } from '@/lib/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { WarningWall } from './warning-wall';
import { SwiperWrapper } from '../swiper-wrapper';

const WarningWallSlider = React.forwardRef(({ data, className, ...props }, ref) => (
  <SwiperWrapper>
    <div
      ref={ref}
      className={cn('c-warning-slider', className)}
      {...props}
    >
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
      >
        {data?.map(warning => (
          <SwiperSlide key={warning.id}>
            <WarningWall
              warning={warning}
              className={className}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </SwiperWrapper>
));
WarningWallSlider.displayName = 'WarningWallSlider';

export { WarningWallSlider };
